export enum AppName {
  Pricing = 'Pricing',
}
